/**
 * @generated SignedSource<<2a596de338535f4500f2018be2897210>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ITPButton_charge$data = {
  readonly availablePaymentMethods: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly customer: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "ITPButton_charge";
};
export type ITPButton_charge$key = {
  readonly " $data"?: ITPButton_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"ITPButton_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ITPButton_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availablePaymentMethods",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "eb80fbf751a19645e5677d5deb6ffd5b";

export default node;
